export type BoardView =
  | 'board'
  | 'list'
  | 'calendar'
  | 'gantt'
  | 'documents'
  | 'dashboard'
  | 'activity'
  | 'timeline'
  | 'whiteboard';

export const BOARD_VIEW_TYPE = {
  List: 1,
  Kanban: 2,
  Calendar: 3,
  Gantt: 4,
  Documents: 5,
  Dashboard: 6,
  Activity: 7,
  Timeline: 8,
  Whiteboard: 9,
} as const;

export type BoardViewType = (typeof BOARD_VIEW_TYPE)[keyof typeof BOARD_VIEW_TYPE];

export interface BoardViewInfo {
  id: string;
  type: number;
  name: string | null;
}

export function viewTypeToSlug(type: number): BoardView {
  switch (type) {
    case BOARD_VIEW_TYPE.List:
      return 'list';
    case BOARD_VIEW_TYPE.Kanban:
      return 'board';
    case BOARD_VIEW_TYPE.Calendar:
      return 'calendar';
    case BOARD_VIEW_TYPE.Gantt:
      return 'gantt';
    case BOARD_VIEW_TYPE.Documents:
      return 'documents';
    case BOARD_VIEW_TYPE.Dashboard:
      return 'dashboard';
    case BOARD_VIEW_TYPE.Activity:
      return 'activity';
    case BOARD_VIEW_TYPE.Timeline:
      return 'timeline';
    case BOARD_VIEW_TYPE.Whiteboard:
      return 'whiteboard';
    default:
      return 'list';
  }
}

export function slugToViewType(slug: BoardView): number {
  switch (slug) {
    case 'list':
      return BOARD_VIEW_TYPE.List;
    case 'board':
      return BOARD_VIEW_TYPE.Kanban;
    case 'calendar':
      return BOARD_VIEW_TYPE.Calendar;
    case 'gantt':
      return BOARD_VIEW_TYPE.Gantt;
    case 'documents':
      return BOARD_VIEW_TYPE.Documents;
    case 'dashboard':
      return BOARD_VIEW_TYPE.Dashboard;
    case 'activity':
      return BOARD_VIEW_TYPE.Activity;
    case 'timeline':
      return BOARD_VIEW_TYPE.Timeline;
    case 'whiteboard':
      return BOARD_VIEW_TYPE.Whiteboard;
    default:
      return BOARD_VIEW_TYPE.List;
  }
}
